import { type ThemeChoice, useTheme } from "@web/lib/theme";
import { Moon, Sun, SunMoon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "../ui/button";

const order: ThemeChoice[] = ["system", "light", "dark"];

export function ThemeToggle() {
  const { t } = useTranslation();
  const [choice, set] = useTheme();
  const Icon = choice === "dark" ? Moon : choice === "light" ? Sun : SunMoon;
  const next = order[(order.indexOf(choice) + 1) % order.length] ?? "system";
  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={() => set(next)}
      aria-label={`${t("theme.label")}: ${t(`theme.${choice}`)}`}
      title={t(`theme.${choice}`)}
    >
      <Icon aria-hidden />
    </Button>
  );
}
